/* Core & libraries */
import React, { useState, useEffect } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router";

/* Helpers, constants, custom methods, internal libraries */
import { usePeopleService } from "../../services/peopleService";
import { useGlobalContext, useGlobalUpdateContext } from "../../contexts/globalContext";
import { colors } from "../../constants/colors";
import { useHasPermission } from "../../hooks/useHasPermission";

/* Components */
import UCButton from "../buttons";

/* Styles */
import styles from "./styles.js"
import DynamicImageLoader from "../dynamicImageLoader";


const TeamDetailsHeader = ({ teamDetails }) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const { teamId } = useParams();

  const { getSharedLink } = usePeopleService();
  const globalProperties  = useGlobalContext();
  const setGlobalProperties  = useGlobalUpdateContext();
  const { checkPermission } = useHasPermission();

  const handleModalClick = async () =>{
    const response = await getSharedLink(teamId, `invitePeopleButton${teamId}`);
    if (response) {
      setGlobalProperties({
        ...globalProperties,
        invitePeopleModal: {
          showInvitePeopleModal: true,
          teamName: response.teamName,
          sharedLink: response.sharedLink,
          active: response.active,
          requiresDomain: response.requiresDomain,
          teamId: teamId,
          isNotDefault: !teamDetails?.default
        }
      })
    }
  }

  return (
    <div className={classes.teamDetailsWrapper}>
      <div className={classes.logo}>
          <DynamicImageLoader imageName={"search-rounded.svg"} />
      </div>
      <h1><FormattedMessage id="teamDetailsNoMembers.title"/></h1>
      <p><FormattedMessage id="teamDetailsNoMembers.description"/></p>
      {
        checkPermission("F_INVITE_USER") &&
          <UCButton
            type="primary"
            onClick={() => handleModalClick()}
            className={classes.invBtn}
            text={<FormattedMessage id="people.inviteButton"/>}
            spinner={{
              name: `invitePeopleButton${teamId}`,
              size: 20,
            }}
          />
      }
    </div>
  )
}

export default TeamDetailsHeader;
